import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
} from "@mui/material";
import BottomButton from "./BottomButton";
import BottomMenu from "./BottomMenu";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { ko } from "date-fns/locale";
import PickersDay from "@mui/lab/PickersDay";
import moment from "moment";
import { useState, forwardRef, useEffect } from "react";
import pr from "../lib/pr";
import styled from "styled-components";
import { LinearProgress } from "@mui/material";
import { styled as mStyled } from "@mui/material/styles";
import { linearProgressClasses } from "@mui/material";
import { withStyles } from "@mui/material";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import { red } from "@mui/material/colors";
import ClearIcon from "@mui/icons-material/Clear";
import { Link, useHistory } from "react-router-dom";
import { TurnOverSequence } from "react-count-number-turnover";
import CountUp from "react-countup";
// import img from "../img/calendar_back.jpg";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import KeyIcon from "@mui/icons-material/Key";
import axios from "axios";
import { isSameDay, isDate, isEqual, getDate } from "date-fns";
import KeyOffIcon from "@mui/icons-material/KeyOff";
import { loginState, configState } from "../lib/State";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";

const calTheme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          maxHeight: "280px",
          height: "100%",
        },
      },
    },
  },
});

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

const theme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          // backgroundImage: `url(${img})`,
          // backgroundSize: "cover",
          // backgroundPosition: "center",
          minWidth: "200px",
          maxWidth: "200px",
          width: "100%",
          maxHeight: "250px",
          height: "100%",
          marginLeft: "20px",
          // color: 'white',
        },
      },
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          maxWidth: "300px",
          width: "100%",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // color: 'white'
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          maxWidth: "29px",
          margin: 0,
          // background: 'yellow',
          height: "10px",
        },
      },
    },
    // PrivatePickersFadeTransitionGroup: {
    //   styleOverrides: {
    //     root: {
    //       fontSize: '10px',
    //     },
    //   },
    // },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeMedium: {
          // color: 'white',
        },
      },
    },
  },
});

const renderWeekPickerDay_old = (date, selectedDates, pickersDayProps) => {
  var d = moment(date).format("D");

  var back = "white";
  var color = "black";
  var disabled = "false";
  var width = "23px";
  var height = "23px";
  var margin = "0 5px";

  // 예약
  if (d == 8) {
    back = "#0092a2";
    color = "white";
  }

  // 출석
  if (d == 3 || d == 15) {
    back = "#f2b4cd";
    color = "white";
  }

  return (
    <PickersDay
      {...pickersDayProps}
      // shouldDisableDate={() => }
      sx={{
        ["&&.Mui-selected"]: {
          background: "none",
          color: "black",
          width: "23px",
          height: "23px",
          margin: "0 5px",
        },
        "&.MuiPickersDay-today": {
          border: "none",
          color: "black",
          width: "23px",
          height: "23px",
          margin: "0 5px",
        },
        "&&.Mui-disabled": { color: "black" },
        margin: `${(props) =>
          props.hiddenDaySpacingFiller ? "0 5px" : "0 10px"}`,
      }}
      // css={css`
      //   background: ${back};
      //   color: ${color};
      //   width: ${width};
      //   height: ${height};
      //   margin: ${margin};
      //   &:hover {
      //     background: 'blue';
      //   }
      // `}
    />
  );
};

function HomeCalendar(props) {
  const [sdate, setSdate] = useState(moment().format("YYYY-MM-01"));
  const [highlightedDays, setHighlightedDays] = useState([1, 2, 15, 26]);
  const minDate = new Date(moment().add(-1, "years"));
  const maxDate = new Date(moment().add(+1, "years"));
  const [rows, setRows] = useState([]);
  const { login } = props;
  const token = get_token();
  const history = useHistory();
  // const [next, setNext] = useState({
  //   class_time: "",
  // });
  const [next, setNext] = useState({ class_time: "" });
  const cid = get_cid();
  const center = get_center(cid);
  const [drows, setDrows] = useState([]);

  // 예약 데이타
  const load_data = async () => {
    let post_data = {
      token: token,
      mcd: login.mcd,
      cid: cid,
      level: login.level,
      sdate: sdate,
    };
    let result = await axios.post(
      configState.api + "/gympass/my_reservation",
      post_data
    );
    if (result.data.success === 1) {
      setRows(result.data.rows);
      setDrows(result.data.drows);
    }
  };
  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
      load_my_next();
    }
  }, [login, sdate]);

  // 내 다음예약
  const load_my_next = async () => {
    let post_data = {
      token: token,
      mcd: login.mcd,
      cid: cid,
      level: login.level,
    };
    let result = await axios.post(
      configState.api + "/gympass/my_reservation_next",
      post_data
    );
    setNext(result.data.row);
  };

  // 예정 클래스 내수업 이동
  const onCountClick = () => {
    if (login.mcd !== "") {
      history.push("/mypage?tab=1");
    }
  };

  // 일정 가져오기 (달력 그리기)
  const renderWeekPickerDay = (date, selectedDates, pickersDayProps) => {
    let d = moment(date).format("D");
    let ym1 = moment(date).format("YYYY-MM-01");
    let ym2 = moment(sdate).format("YYYY-MM-01");

    // 같은달?
    // 지난달 다음달 숫자 빼기 위해서
    let this_month = false;
    if (ym1 === ym2) {
      this_month = true;
    }

    // 예약이 있나?
    let is_reserve = false;
    let idx = drows.findIndex(
      (el) => moment(el.class_date).format("DD") === moment(date).format("DD")
    );
    if (idx > -1) {
      is_reserve = true;
    }

    return (
      <Box
        key={d}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ width: 40, height: 30 }}
      >
        <Box display="flex" alignItems="center" justifyContent="cetner">
          {this_month && is_reserve && drows[idx].pt_type === "GX" && (
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize={12}
              sx={{
                backgroundColor: "#0092a2",
                width: 30,
                height: 30,
                borderRadius: "50%",
                color: "white",
                fontWeight: "bold",
              }}
            >
              {d}
            </Typography>
          )}
          {this_month && is_reserve && drows[idx].pt_type === "PT_MANAGER" && (
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize={12}
              sx={{
                backgroundColor: "#3a68de",
                width: 30,
                height: 30,
                borderRadius: "50%",
                color: "white",
                fontWeight: "bold",
              }}
            >
              {d}
            </Typography>
          )}
          {this_month && is_reserve && drows[idx].pt_type === "PT_TRAINER" && (
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize={12}
              sx={{
                backgroundColor: "#dea23a",
                width: 30,
                height: 30,
                borderRadius: "50%",
                color: "white",
                fontWeight: "bold",
              }}
            >
              {d}
            </Typography>
          )}
          {this_month && !is_reserve && (
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize={12}
              sx={{ width: 30, height: 30, borderRadius: "50%" }}
            >
              {d}
            </Typography>
          )}
          {!this_month && (
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize={12}
              sx={{ width: 30, height: 30, borderRadius: "50%" }}
            ></Typography>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "90%",
        borderRadius: "10px",
        boxShadow: "5px 5px 5px #e7e7e7",
      }}
    >
      <ThemeProvider theme={typoTheme}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "15px",
            color: "white",
            background: "#0092a2",
            borderRadius: "10px 10px 0 0",
            padding: "5px 10px",
            fontFamily: "BebasNeue",
          }}
          onClick={onCountClick}
        >
          {next.class_time === "" ||
          next.class_time === undefined ||
          next.class_time === 0 ? (
            <Box
              sx={{
                fontWeight: "bold",
              }}
            >
              예정 클래스가 없습니다.&nbsp;&nbsp;
            </Box>
          ) : (
            <Box
              sx={{
                fontWeight: "bold",
              }}
            >
              다음 예약 클래스&nbsp;&nbsp;
            </Box>
          )}

          <Box
            sx={{
              fontFamily: "BebasNeue",
              fontSize: "20px",
            }}
          >
            {next.class_time === "" ||
            next.class_time === undefined ||
            next === 0 ? (
              <> </>
            ) : (
              <>
                <Box
                  onClick={() => {
                    history.push("/mypage?tab=1");
                  }}
                >
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {next.pt_type === "GX"
                      ? "그룹"
                      : next.pt_type === "PT_MANAGER"
                      ? "점장"
                      : "트레이너"}
                  </span>{" "}
                  {moment(next.class_time).format("YYYY-MM-DD HH:mm")}
                </Box>
              </>
            )}
          </Box>
        </Box>
      </ThemeProvider>

      <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
        <ThemeProvider theme={calTheme}>
          <StaticDatePicker
            autoOk
            views={["year", "month", "day"]}
            minDate={minDate}
            maxDate={maxDate}
            displayStaticWrapperAs="desktop"
            value={sdate}
            onChange={(newValue) => {
              setSdate(moment(newValue).format("YYYY-MM-01"));
            }}
            renderInput={(params) => <TextField {...params} />}
            renderDay={renderWeekPickerDay}
            onMonthChange={(newValue) => {
              setSdate(moment(newValue).format("YYYY-MM-01"));
            }}
          ></StaticDatePicker>
        </ThemeProvider>
      </LocalizationProvider>

      <Box display="flex" style={{ width: 280, margin: "0 auto" }}>
        <Box
          flex="1"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mt: -2, mb: 1 }}
        >
          <Box
            sx={{
              background: "#0092a2",
              width: "10px",
              height: "10px",
              borderRadius: 10,
              marginRight: "5px",
              ml: 1,
            }}
          ></Box>
          <Box sx={{ fontSize: "12px" }}>
            {center.pt_coupon_sale === false ? "예약" : "그룹"}
          </Box>
          {drows.filter((el) => el.pt_type === "PT_MANAGER").length > 0 && (
            <>
              <Box
                sx={{
                  background: "#3a68de",
                  width: "10px",
                  height: "10px",
                  borderRadius: 10,
                  marginRight: "5px",
                  ml: 1,
                }}
              ></Box>
              <Box sx={{ fontSize: "12px" }}>점장</Box>
            </>
          )}
          {drows.filter((el) => el.pt_type === "PT_TRAINER").length > 0 && (
            <>
              <Box
                sx={{
                  background: "#dea23a",
                  width: "10px",
                  height: "10px",
                  borderRadius: 10,
                  marginRight: "5px",
                  ml: 1,
                }}
              ></Box>
              <Box sx={{ fontSize: "12px" }}>트레이너</Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
export default HomeCalendar;
